import { differenceInDays, format, parse, parseISO } from "date-fns";
import { formatInTimeZone, utcToZonedTime } from "date-fns-tz";
import { ptBR } from "date-fns/locale";

const LibDateTime = {
	parseDelphiLocal: (strISO, formatPattern = "dd/MM/yyyy 'às' HH:mm") => {
		if (!strISO) return "";
		try {
			// Remove o 'Z' para que o Date/parseISO não converta de UTC para Local,
			// garantindo que a hora "pura" do banco seja exibida exatamente como é.
			const cleanStr = strISO.replace("Z", "");
			const date = parseISO(cleanStr);
			return format(date, formatPattern, { locale: ptBR });
		} catch (e) {
			return strISO;
		}
	},
	formatDelphiLocalForInput: (strISO) => {
		if (!strISO) return "";
		try {
			const cleanStr = strISO.replace("Z", "");
			const date = parseISO(cleanStr);
			return format(date, "yyyy-MM-dd'T'HH:mm");
		} catch (e) {
			return strISO;
		}
	},
	diasDesdeDelphi: (strISO) => (strISO ? differenceInDays(new Date(), parseISO(strISO.replace("Z", ""))) : 0),
	// compara duas datas, a primeira tem q ser menor que a segunda
	isDateFilterValid: async (dtInitial, dtFinal) => {
		const dtIni = parse(dtInitial, "dd/MM/yyyy HH:mm:ss", new Date());
		const dtFim = parse(dtFinal, "dd/MM/yyyy HH:mm:ss", new Date());

		if (dtIni > dtFim) {
			return false;
		}

		return true;
	},
	formatedUtcToZonedTime: (value) => {
		//recebe utc e converte para o fuso horário de São Paulo
		//usado principalmente para converter a data do banco para o formato correto
		//quando recebe os dados desta forma 2025-01-18 para não colocar 2025-01-17 por causa do fuso horário
		const newDate = utcToZonedTime(value, "America/Sao_Paulo");

		return newDate;
	},
	formatDateToSaoPaulo: (date, pattern = "dd/MM/yyyy HH:mm:ss") => {
		if (!date) return "";

		const timeZone = "America/Sao_Paulo";
		const zonedDate = utcToZonedTime(date, timeZone);
		const formatted = format(zonedDate, pattern, { timeZone });

		return formatted;
	},
	// formatDateInTimeZone(value) {
	// 	//recebe uma data utc e formata para o fuso horário desejado
	// 	//data_pagto: '2025-11-14T09:56:32.713Z',
	// 	//e retorna 14/11/2025 09:56:32
	// 	return formatInTimeZone(value, "UTC", "dd/MM/yyyy HH:mm:ss");
	// },

	formatDateInTimeZone(value, { timeZone = "UTC", pattern = "dd/MM/yyyy HH:mm:ss" } = {}) {
		//recebe uma data utc e formata para o fuso horário desejado
		//data_pagto: '2025-11-14T09:56:32.713Z',
		//e retorna 14/11/2025 09:56:32
		if (!value) return "";

		return formatInTimeZone(value, timeZone, pattern);
	},

	dayOfMonth: (date) => {
		return date.getDate(date);
	},
	getLastDayOfMonth: (date) => {
		// recebo um date ex.: const dataVencimento = new Date(dataVencimento.getTime());
		// Cria um novo objeto Date usando o ano e o mês da data fornecida,
		// mas definindo o dia como 0. Isso retorna o último dia do mês anterior
		// ao mês da data fornecida.
		return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
	},
};

export default LibDateTime;

// import { format } from "date-fns";
// const formattedDate = format(new Date(), "dd/MM/yyyy"); Exemplo de saída: "04/02/2025"
